import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>404 - Page Not Found</h1>
      <p style={{ marginBottom: "35px" }}>
        The page you are looking for does not exist.
      </p>
      <Link to="/" className="nonFound">
        Go to Login
      </Link>
    </div>
  );
}

export default NotFound;
